import { Message } from "element-ui";
/* 判断是否为正整数 */
const isInteger = function (num) {
  if (!/(^[0-9]\d*$)/.test(num)) {
    return false;
  }
  return true;
};

/* 去除字符串的空格子 */
const trimString = (string) => {
  if (typeof string !== "string") {
    string = string.toString();
  }
  return string.replace(/\s+/g, "");
};

/* 字符串截取 */
const mSubstr = (string, start, length) => {
  if (typeof string !== "string") {
    string = string.toString();
  }
  return string.substr(start, length);
};

const mergeRouter = (routes, routerMap) => {
  let index = 0;
  routes.forEach((route, i) => {
    if (route.path === "/home") index = i;
  });

  routerMap.forEach((item) => {
    if (item.constructor === Array) {
      item.forEach((val) => {
        routes[index].children.push(val);
      });
    } else if (item.constructor === Object) {
      routes[index].children.push(item);
    }
  });
  return routes;
};

// 滚动条动画
const scrollAnimation = (currentY, targetY, ref) => {
  // 计算需要移动的距离
  const needScrollTop = targetY - currentY;
  let _currentY = currentY;
  setTimeout(() => {
    // 一次调用滑动帧数，每次调用会不一样
    const dist = Math.ceil(needScrollTop / 10);
    _currentY += dist;
    ref.scrollLeft = _currentY;
    // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
    if (needScrollTop > 10 || needScrollTop < -10) {
      scrollAnimation(_currentY, targetY, ref);
    } else {
      ref.scrollLeft = _currentY;
    }
  }, 1);
};

// 判断商品分类是否属于套装
// 这个包含"套装"俩字的都算, 写在这里单纯是为了方便改动
const goodsIsSuit = (cat_name) => {
  const index = cat_name.indexOf("套装");
  return index > -1;
};

/**
 * 助手函数,大部分页面都有用的
 * @author drd
 */
class Excalibur {
  /**
   * 设置默认时间范围
   * @param int range 范围,单位 day
   * @param string intime 时分秒格式
   */
  getDateRange(range, intime) {
    const _now = new Date();
    const _rangeAgo = new Date(_now.getTime() - range * 86400000);
    const _format = (dateObj, _intime) => {
      const y = [
        // Y-m-d
        dateObj.getFullYear(),
        Number(dateObj.getMonth() + 1)
          .toString()
          .replace(/^(\d)$/, "0$1"),
        Number(dateObj.getDate())
          .toString()
          .replace(/^(\d)$/, "0$1"),
      ];
      let h = [
        _intime == "start" ? "00" : "23", // 时
        _intime == "start" ? "00" : "59", // 分
        _intime == "start" ? "00" : "59", // 秒
      ];
      if (!_intime) {
        h = [
          Number(dateObj.getHours())
            .toString()
            .replace(/^(\d)$/, "0$1"),
          Number(dateObj.getMinutes())
            .toString()
            .replace(/^(\d)$/, "0$1"),
          Number(dateObj.getSeconds())
            .toString()
            .replace(/^(\d)$/, "0$1"),
        ];
      }
      return `${y.join("-")} ${h.join(":")}`;
    };

    return [
      _format(_rangeAgo, intime ? "start" : false),
      _format(_now, intime ? "end" : false),
    ];
  }

  /**
   * 获取某个点的时间
   * @param hours undfined时只显示日期
   * @author drd
   */
  getDateTimeOnHours(range, hours) {
    const _now = new Date();
    const _range = Number(range);
    const _rangeAgo = new Date(_now.getTime() + _range * 86400000);
    const _format = (dateObj) => {
      const y = [
        // Y-m-d
        dateObj.getFullYear(),
        Number(dateObj.getMonth() + 1)
          .toString()
          .replace(/^(\d)$/, "0$1"),
        Number(dateObj.getDate())
          .toString()
          .replace(/^(\d)$/, "0$1"),
      ];
      let h = [];
      if (hours > -1) {
        h = [hours, "00", "00"];
      }
      return `${y.join("-")} ${h.join(":")}`;
    };
    return _range >= 0
      ? [_format(_now), _format(_rangeAgo)]
      : [_format(_rangeAgo), _format(_now)];
  }
}

/**
 * 调用计算机的摄像头
 * @author drd
 */
class Camera {
  /**
   * 类初始化
   * @author drd
   */
  constructor(options) {
    this.media = navigator.mediaDevices;
    // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
    if (this.media === undefined) {
      this.media = {};
    }

    // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
    // 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
    if (this.media.getUserMedia === undefined) {
      this.media.getUserMedia = function (constraints) {
        // 首先，如果有getUserMedia的话，就获得它
        const getUserMedia =
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.getUserMedia;

        // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
        if (!getUserMedia) {
          return Promise.reject(
            new Error("getUserMedia is not implemented in this browser")
          );
        }

        // 否则，为老的navigator.getUserMedia方法包裹一个Promise
        return new Promise(function (resolve, reject) {
          getUserMedia.call(navigator, constraints, resolve, reject);
        });
      };
    }
    if (!this.media) {
      throw "未找到浏览器的媒体对象或非https网站, 请联系技术人员";
      return this;
    }
    return this;
  }

  /**
   * 拍照获取图片
   * @author drd
   */
  startVideo(video) {
    this.startMedia().then((stream) => {
      this.track = stream;
      console.log("---video", video);
      video.srcObject = stream;
      video.play();
    });
  }

  stopMedia() {
    if (this.track) {
      const tracks = this.track.getTracks(); // 有多少关多少
      tracks.forEach((v) => {
        v.stop();
      });
    }
  }

  /**
   * 调用media
   * @author drd
   */
  startMedia() {
    return this.media.getUserMedia({
      video: true,
      audio: false,
    });
  }
}

// 根据拖进来的文件生成 File 对象, 目前兼容本地文件拖入和网页图片拖入
const dropImg = (e) => {
  // 阻止浏览器的默认行为
  e.preventDefault();

  const file_name = (mime) => {
    return `${
      new Date().getTime() + Math.random().toString().replace(".", "")
    }.${mime}`;
  };
  return new Promise((resolve, reject) => {
    // 拖动本地文件就会出现这个了
    const file = e.dataTransfer.files[0];
    if (!file) {
      // 如果没有实体文件, 则找到img标签的src, 然后转换成实体文件
      const image_text = e.dataTransfer.getData("text/html");
      if (!image_text) {
        return reject("拖拽进来的内容无法读取到图片");
      }
      let img_tag = image_text.match(/<img(.*?)>/i);
      // 没匹配到的就是null
      if (!img_tag) {
        return reject("拖拽内容没有图片标签, 无法读取图片");
      }
      img_tag = img_tag[0]; // 直接取下
      // 获取图片的地址
      let src = img_tag.match(/src=\"(.*?)\"/)[1];
      if (src.length == 0) {
        return reject("拖拽内容没有图片地址");
      }
      // 目前只发现这个字符会被转换掉, 如果还有发现, 请在数组后面往下加
      [{ search_val: /\&amp;/g, replace_val: "&" }].forEach((v) => {
        src = src.replace(v.search_val, v.replace_val);
      });
      // 创建canvas, 使用canvas创建图片并转换成 File

      // 创建实体dom, 给canvas用
      const image = document.createElement("img");
      image.crossOrigin = "Anonymous"; // 解决跨域图片问题 但是图片的服务器必须有这个头 Access-Control-Allow-Headers: *
      image.src = src;
      image.onload = (e) => {
        const cvs = document.createElement("canvas");
        // cvs.crossOrigin = undefined;
        const ctx = cvs.getContext("2d");

        cvs.width = image.width;
        cvs.height = image.height;
        ctx.drawImage(image, 0, 0, cvs.width, cvs.height);
        // 可能转换失败
        try {
          cvs.toBlob(
            (blob) => {
              blob.name = file_name(blob.type);
              resolve(blob);
            },
            "image/jpeg",
            1
          );
        } catch (e) {
          reject(`图片下载失败, 可能是跨域安全访问不允许; 错误信息(${e})`);
        }

        // document.body.appendChild(cvs);
      };
      image.onerror = (e) => {
        e = typeof e === "object" ? JSON.stringify(e) : e;
        reject(
          `图片加载失败, 错误信息(${e}), 可能是跨域安全访问不允许, 请手动保存图片后上传`
        );
      };
      return;
    }

    resolve(file);
  });
};

// 执行打印命令
const doPrint = (print_data) => {
  return new Promise((resolve, reject) => {
    let wsuri = "ws://localhost:13528"; // ws地址
    if (document.location.protocol == "https:") {
      wsuri = "wss://localhost:13529"; // https wss地址
    }
    const socket = new WebSocket(wsuri);
    socket.onerror = (_) => {
      reject("打印机连接错误, 打印失败");
    };
    socket.onopen = (_) => {
      socket.send(JSON.stringify(print_data));
      socket.close();
    };
    resolve();
  });
};

/**
 * @description 记录和显示错误
 * @param {Error} error 错误对象
 */
const errorLog = (error) => {
  // 打印到控制台
  console.log(">>>>>> Error >>>>>>");
  console.log(error);
  // 显示提示
  Message({
    message: error.message,
    type: "error",
    duration: 5 * 1000,
  });
};

/**
 * @description 创建一个错误
 * @param {String} msg 错误信息
 */
const errorCreate = (msg) => {
  const error = new Error(msg);
  errorLog(error);
  throw error;
};

/**
 * 预览一张图片
 * @author drd
 */
const viewImg = (img_url) => {
  const mask = document.createElement("div");
  mask.style =
    "background-color: rgba(38,38,38,.5); position: fixed;height: 100vh;width: 100vw;z-index:9999;top:0;display:flex";
  const img_dom = document.createElement("img");
  img_dom.style = "max-width:100%; max-height:100%;margin:auto";
  img_dom.src = img_url;
  mask.onclick = (_) => document.body.removeChild(mask);
  mask.appendChild(img_dom);
  document.body.appendChild(mask);
};

const $post = (vue) => {
  return (url, params) => {
    return new Promise((resolve, reject) => {
      vue.$http.post(url, params).then((rs) => {
        if (rs.data.code != 200) {
          vue.$message.e(rs.data.msg);
          return reject(rs.data);
        }
        resolve(rs.data.data);
      });
    });
  };
};

// 自动关闭自己
const $removeSelf = () => {
  // return ()
  return ($self) => {
    let home = $self.$parent.$parent.$parent.$parent;
    let i = 20;
    while (true) {
      if (home.componentsName == "home") {
        home.removeTab(home.removeHomePrefix($self.$route.path));
        break;
      }
      if (i == 0) {
        break;
      }
      home = home.$parent;
      i--;
    }
  };
};

const excalibur = new Excalibur();
export {
  $post,
  $removeSelf,
  Camera,
  doPrint,
  dropImg,
  errorCreate,
  errorLog,
  excalibur,
  goodsIsSuit,
  isInteger,
  mergeRouter,
  mSubstr,
  scrollAnimation,
  trimString,
  viewImg,
};



// WEBPACK FOOTER //
// ./src/tool/helper.js